import i18n from '@dms/i18n';

import {CodelistDetail} from '../../components/CodelistDetail/CodelistDetail';

export function RentalCodelistDetail() {
  return (
    <CodelistDetail
      breadcrumbs={[
        {
          isCurrentPage: true,
          label: i18n.t('entity.rental.labels.rental'),
        },
      ]}
    />
  );
}
